










import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import { CookieService } from '@/services/cookie'
import {
  cacheUserAttribute,
  getUserAttributeCache,
  hasApiToken as hasWebCustomerServiceApiToken,
  WebCustomerServiceUserAttr,
} from '@/vendor/web-customer-service-tool'
import WebCustomerServiceTool from '@/vendor/WebCustomerServiceTool.vue'
import { log } from '@spa/log'
import { PluginMixin } from '@spa/mixins/plugin'
import { LoadedCartSummary } from '@spa/store/modules/cart/types'
import { User } from '@spa/store/modules/user/types'

@Component({
  components: {
    WebCustomerServiceTool,
  },
})
export default class ThirdPartyTool extends Mixins<PluginMixin>(PluginMixin) {

  userAttribute: WebCustomerServiceUserAttr = {}
  isUserCurrentCompleted: boolean = false

  async created() {

    const userAttribute: WebCustomerServiceUserAttr | null = await this.getWebCustomerServiceUserAttribute()

    if (userAttribute) {
      this.userAttribute = userAttribute
      cacheUserAttribute(this.userAttribute)
      this.isUserCurrentCompleted = true
    }
  }

  get canExecuteWebCustomerService(): boolean {

    if (!this.isValidWebCustomerService) {

      return false
    }

    if (this.isGuest) {

      return true
    }

    // summary apiが成功して合計金額が取得できるまでは実行しない
    if (!this.isCartSummaryLoaded) {

      return false
    }

    // 仮会員
    if (!this.isRegistered) {

      return true
    }

    // 本会員はユーザー情報が必要
    if (this.isUserCurrentCompleted) {

      return true
    }

    return false
  }

  get isValidWebCustomerService(): boolean {

    return hasWebCustomerServiceApiToken()
  }

  get isGuest(): boolean {
    return CookieService.isGuest()
  }

  get isRegistered(): boolean {
    return CookieService.isRegistered()
  }

  get isCartSummaryLoaded(): boolean {
    return this.loadedCartSummaryList.length > 0
  }

  get cartTotalPrice(): number {
    // TODO: 本来はブランドコンテキストに基づいて対象summaryを決定するべき
    let totalPrice = 0
    for (const summary of this.loadedCartSummaryList) {
      totalPrice += summary.totalPrice
    }

    return totalPrice
  }

  get loadedCartSummaryList(): LoadedCartSummary[] {
    return this.$store.getters['cart/loadedCartSummaryList']
  }

  get userCurrent(): User {
    return this.$store.state.user.user
  }

  get errorOnLoadUserCurrent(): Error | undefined {
    return _.get(this.$store.state.user, 'error.load')
  }

  private async getWebCustomerServiceUserAttribute(): Promise<WebCustomerServiceUserAttr | null> {

    // 接客ツール側のログインは会員登録しているユーザーのログイン状態を対象としている。
    // そのため本会員以外はユーザー情報を取得しない
    if (!this.isRegistered) return null

    const userAttributeCache = getUserAttributeCache()
    if (userAttributeCache) {

      return userAttributeCache
    }

    await this.$store.dispatch('user/get')
    if (this.errorOnLoadUserCurrent) {
      log.error({ message: `vue third party tool: get user_current is failed.` })

      return null
    }

    return this.extractWebCustomerServiceUserAttribute(this.userCurrent)
  }

  private extractWebCustomerServiceUserAttribute(user: User): WebCustomerServiceUserAttr {

    return {
      id: user.id || '',
      elapsedDays: user.elapsed_days_last_order || 0,
      orderTimes: user.order_times || 0,
    }
  }
}
